import $ from 'jquery';

const $imageVideoContainer = $('.js-image-video');
const $startButton = $('.js-start-animation');
const $continueButton = $('.js-continue-animation');
const $calloutColumn = $('.js-callout-column');
const $calloutNavigation = $('.js-callout-navigation');
const MAX_IMAGES = 277;
const FRAME_RATE = 20;
const STOP_POINTS = [
  66,
  120,
  213,
];
const preLoadedImages = [];

let currentImageCounter = 1;
let allowClick = true;

if ($imageVideoContainer.length) {
  // Preload first section's images

  for (let i = 1; i <= STOP_POINTS[0]; i += 1) {
    preLoadedImages[i] = new Image();
    preLoadedImages[i].src = `/SiteFiles/img/brushless-animation/out-${leftPad(i, 3)}.jpg`;
  }

  $startButton.click(processAnimation);
  $continueButton.click(processAnimation);
  $calloutNavigation.find('li').click((e) => {
    const itemIndex = $(e.currentTarget).index();

    // The active dot has been clicked.
    if (itemIndex === $('.js-callout:visible').index('.js-callout')) {
      return;
    }

    processAnimation(e, itemIndex - 1);
  });
}

function processAnimation(e, transitionTo) {
  if (!allowClick) {
    return;
  }

  allowClick = false;

  $calloutColumn.find('*').removeClass('fully-loaded');
  $('.js-callout-navigation ul li').removeClass('is-active');

  $calloutColumn.addClass('animation-in-progress');
  $(e.currentTarget).removeClass('clickable');


    // Scroll to the top of the video on mobile.
  if (matchMedia('(max-width: 768px)').matches) {
    const $siteHeader = $('header');
    let scrollOffset = 0;

    if ($siteHeader.length) {
      scrollOffset -= $siteHeader.height();
    }

    scrollOffset += $imageVideoContainer.offset().top;

    $('html, body').animate({
      scrollTop: scrollOffset,
    }, 1000);
  }


  if (currentImageCounter === MAX_IMAGES) {
    currentImageCounter = 1;
  }

  if (preLoadedImages.length < MAX_IMAGES) {
    for (let i = STOP_POINTS[0]; i <= MAX_IMAGES; i += 1) {
      preLoadedImages[i] = new Image();
      preLoadedImages[i].src = `/SiteFiles/img/brushless-animation/out-${leftPad(i, 3)}.jpg`;
    }
  }

  let transitionToFrame;

  if (transitionTo === undefined) {
    transitionToFrame = STOP_POINTS[STOP_POINTS.indexOf(currentImageCounter - 1) + 1];
  } else if (transitionTo === -1) {
    transitionToFrame = 0;
  } else {
    transitionToFrame = STOP_POINTS[transitionTo];
  }

  if (transitionToFrame === undefined) {
    transitionToFrame = MAX_IMAGES;
  }

  const $nextCallout = $(`.js-callout-${STOP_POINTS.indexOf(transitionToFrame) + 2}`);
  const $currentCallout = $('.js-callout:visible');
  $currentCallout.fadeOut(() => {
    $nextCallout.fadeIn();
  });

  const interval = setInterval(() => {
    if (currentImageCounter === transitionToFrame || currentImageCounter === MAX_IMAGES) {
      allowClick = true;
      clearInterval(interval);

      $calloutColumn.removeClass('animation-in-progress');
      $nextCallout.find('.js-start-animation, .js-continue-animation').addClass('clickable');

      $('.js-callout-navigation ul li')
      .eq($nextCallout.index('.js-callout'))
      .addClass('is-active');


      $nextCallout.addClass('fully-loaded');
    }

    // If we haven't reached the max images, transition to the next image.
    if (currentImageCounter < MAX_IMAGES) {
      if (transitionToFrame >= currentImageCounter) {
        currentImageCounter += 1;
      } else {
        currentImageCounter -= 1;
      }
      // eslint-disable-next-line
      $imageVideoContainer.attr('src', `/SiteFiles/img/brushless-animation/out-${leftPad(currentImageCounter, 3)}.jpg`);
    }
  }, 1000 / FRAME_RATE);
}

function leftPad(value, padding) {
  const zeroes = new Array(padding + 1).join('0');
  return (zeroes + value).slice(-padding);
}
